import { IAuthenticator } from "@/domain/repositories/Auth";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";

export class AzureAuthenticator implements IAuthenticator {
  type: string;
  msalInstance: PublicClientApplication;

  constructor() {
    this.type = "azure";

    if (!process.env.NEXT_PUBLIC_AZURE_CLIENT_ID) {
      throw new Error(
        "Missing environment variable NEXT_PUBLIC_AZURE_CLIENT_ID"
      );
    }

    if (!process.env.NEXT_PUBLIC_AZURE_TENANT_ID) {
      throw new Error(
        "Missing environment variable NEXT_PUBLIC_AZURE_TENANT_ID"
      );
    }

    const msalConfig: Configuration = {
      auth: {
        clientId: process.env.NEXT_PUBLIC_AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.NEXT_PUBLIC_AZURE_TENANT_ID}`,
        redirectUri: "/",
      },
    };

    this.msalInstance = new PublicClientApplication(msalConfig);
    this.msalInstance.initialize();
  }

  async authenticate() {
    const loginRequest = {
      scopes: ["user.read"],
    };

    const response = await this.msalInstance.loginPopup(loginRequest);
    const token = response.accessToken;

    return { token };
  }

  async deauthenticate() {
    await this.msalInstance.logoutPopup();
  }
}
